import { CountryInput } from '@commenda/kakashi';
import { Country } from '@prisma/client';
import { useContext } from 'react';
import { FormContext } from '../../hooks/FormContext';
import { isRuleActive } from '../../utils/validation';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const CountryInputComponent = ({
  fieldId,
  label,
  description,
  placeholder,
  props = {},
  guidance,
  validation,
}: {
  fieldId: string;
  label?: string;
  description?: string;
  placeholder?: string;
  props?: {
    disabled?: boolean;
    type?: 'single' | 'multiple';
    countries?: Country[];
    countriesToNotDisplay?: Country[];
    maxCount?: number;
  };
  guidance?: {
    text?: string;
  };
  validation?: {
    rules?: {
      required?:
        | boolean
        | {
            enabled?: boolean;
            message?: string;
          };
    };
  };
}) => {
  const { formData, updateField, errors, validateField, isFieldVisible, isFieldDisabled } =
    useContext(FormContext);

  const type = props.type || 'single';
  const disabled = props.disabled || isFieldDisabled(fieldId);
  const isRequired = isRuleActive(validation?.rules?.required, isFieldVisible);

  // Handle single vs multiple value types
  const singleValue = type === 'single' ? (formData[fieldId] as string | null) ?? null : null;
  const multipleValue = type === 'multiple' ? (formData[fieldId] as string[]) ?? [] : [];

  const handleSingleChange = (val: string | null) => {
    updateField(fieldId, val);
    validateField(fieldId, val, validation?.rules);
  };

  const handleMultipleChange = (val: string[]) => {
    updateField(fieldId, val);
    validateField(fieldId, val, validation?.rules);
  };

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          description={description}
          guidance={guidance?.text}
          isRequired={isRequired}
        />
      )}
      {type === 'single' ? (
        <CountryInput
          type="single"
          value={singleValue}
          onValueChange={handleSingleChange}
          placeholder={placeholder}
          error={errors[fieldId]}
          disabled={disabled}
          countries={props.countries}
          countriesToNotDisplay={props.countriesToNotDisplay}
        />
      ) : (
        <CountryInput
          type="multiple"
          value={multipleValue}
          onValueChange={handleMultipleChange}
          placeholder={placeholder}
          error={errors[fieldId]}
          disabled={disabled}
          countries={props.countries}
          countriesToNotDisplay={props.countriesToNotDisplay}
          maxCount={props.maxCount}
        />
      )}
    </div>
  );
};
